import React, { useEffect, useState }from 'react';
import { Typography, Grid, Button } from "@material-ui/core";
import { BrowserRouter,Link } from "react-router-dom";
import SwipeDrawer from './SwipeDrawer';
import UnauthorizedAccess from './UnauthorizedAccess';
import Alert from '@material-ui/lab/Alert';
import { useDispatch, useSelector } from "react-redux";
//import { getLandingMenuList } from "../ReduxStore/Actions";
import {AppIDReducer} from "../ReduxStore/Reducers/reducers";
import {storeLandingMenuItemsAction,storeEperformanceLandingMenuItemsAction,storePhyInvLandingMenuItemsAction} from "../ReduxStore/Actions/actions";


import Loader from "./Loader/Loading";
import {
    storeUserDetailsAction,
    saveUIDAction,
    saveBearerTokenAction,
    AppIDAction
  
  } from "../ReduxStore/Actions/actions";

export default function ProjInv({ firstName, lastName, Eperformance, physicalInventory }) {
    const dispatch = useDispatch();
    const [userfirstname, setFirstname] = useState('');
    const [EperforMenuName,setEperformenuname] = useState('');
    const [EperforSubMenuName,setEperforSubmenuname] = useState('');
    const [PhyInvMenuName,setPhyInvMenuName] = useState('');
    const [phyInventorySubMenuName,setphyInventorySubMenuName] = useState('');
    const [userlastName, setLastName] = useState('');
    const [errorMessages, setErrorMessages] = useState([]);
    const [iserror, setIserror] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [data, setData] = useState('');
    const [loadedData,setLoadedData]= useState(null);
    const [phyInvData, setphyInvData] = useState('');
    const [isAuthorize, setisAuthorize] = useState(false);
    const token = useSelector((state) => state.saveAzureTokenReducer.token);
    const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData);
    const bearerToken = useSelector(
    (state) => state.saveBearerTokenReducer.bearerToken);
    const uId = useSelector((state) => state.saveUIDReducer.uid);
    const appID = useSelector((state) => state.AppIDReducer.AppID);
    const landingMenuItems =
      useSelector((state) => state.storeLandingMenuItemsReducer.menuItems) || [];
    //const [iserror, setIserror] = useState(false);
    function showMessage(errorList, flag, severity){
        setErrorMessages(errorList);
        setIserror(flag);
        setSeverity(severity);
    }
    const handleErrorClose = (e) => {
        setIserror(false);
    }
    useEffect(() => {
       // console.log('EperforMenuName',EperforMenuName);
        //console.log('loadedData',loadedData)
        //console.log("Eperformance", Eperformance);
       // console.log("physicalInventory", physicalInventory);
        if(loadedData){
            return;
        }
        
            getLandingMenuList();
        
       
       // phyInventory(1);
       // ePerformance(1);
       getEperformancesubmenu();
       getPhyInvLandingmenues();
        savingFlagValue();
        if (Eperformance != null) {
            setFirstname(firstName);
            setLastName(lastName);
        }
        else if (physicalInventory != null) {
            setFirstname(physicalInventory.firstName);
        }
        if (Eperformance == null) {
            setFirstname(firstName);
            setLastName(lastName);
        }
         if (physicalInventory == null) {
            setFirstname(physicalInventory.firstName);
        }
           
        //console.log("Eperformance", Eperformance);
        //console.log("physicalInventory", physicalInventory);
        
        
    }, [loadedData]);


    
    const uid= localStorage.getItem('uid');
    const bearer =  localStorage.getItem('bearer');
    const userdetails = localStorage.getItem('userdetails');
    let userdetails1 = JSON.parse(userdetails);
    

    function getLandingMenuList() {
       let appID =0;
       let headers={};

       headers = {
        //Authorization: "Bearer " + bearer,
        //UserEmail: userdetails1.emailId,
        //userId: uid,
        RoleName: "Admin",
        //Gid: userdetails1.gid,
        //Roleid: userdetails1.roleId,
        //AzureToken: token,
      };
      

        return fetch("MasterDetails/GetLandingMenuData?appid=" + appID, {
            headers: headers
        })
           .then((response) => response.json())
           .then((res) => {
            // if((Eperformance != null && Eperformance.response && Eperformance.response.applicationId===2) && (physicalInventory != null && physicalInventory.response && physicalInventory.response.applicationId===3)){
            dispatch(storeLandingMenuItemsAction(res)) 
            //}
            setLoadedData(res);
            //console.log(res,'laandingmenus')
            res?.result?.map((item, index)=>{
                if(item.isMainMenu==true && item.menuName==='E - Performance'){
                   //const EperforMenuName=item.menuName;
                    setEperformenuname(item.menuName)
                   
                }else if(item.isMainMenu==true && item.menuName==='Physical Inventory')
                {
                    //const PhyInvMenuName=item.menuName
                    setPhyInvMenuName(item.menuName)
                }
            })
          
            
             return res.result;
             
           })
           .catch((error) => {
             console.log("Error : ", error);
           });
       }

    function savingFlagValue() {
       // console.log(1);
        localStorage.setItem("ApplicationId", 1);
    }

    function getEperformancesubmenu()
    {
        if (Eperformance != null && Eperformance.response  && Eperformance.response.applicationId===2) {
            const appID=Eperformance.response.applicationId;
            const headers = {
            Authorization: "Bearer " + Eperformance.tokenString,
            UserEmail: Eperformance.response.emailId,
            userId: Eperformance.uid,
            RoleName: Eperformance.response.roleName,
            Gid: Eperformance.response.gid,
            Roleid: Eperformance.response.roleId,
           
            };
          return fetch ("MasterDetails/GetLandingMenuData?appid="+ appID ,{headers:headers
          })
             .then((response) => response.json())

             .then((data) => {
                dispatch(storeEperformanceLandingMenuItemsAction(data)) 
               // console.log(data,'eperformance laandingmenus');
                setData(data);
                
               
               
             })
             .catch((error) => {
               console.log("Error : ", error);
             });
            
            
            
        }else{
            setEperformenuname(null);
        }
            

    }
    function ePerformance() 
    {
    if (Eperformance != null && Eperformance.response && Eperformance.response.applicationId===2) {
                dispatch(saveUIDAction(Eperformance.uid));
                dispatch(saveBearerTokenAction(Eperformance.tokenString));
                dispatch(storeUserDetailsAction(Eperformance.response));
                dispatch(AppIDAction(Eperformance.response.applicationId))

                const filterItems=data?.result?.filter(item=> item.isMainMenu===true);
                dispatch(storeLandingMenuItemsAction(filterItems)) 
                localStorage.setItem("ApplicationId", 2);
                //window.location.href = '/Home';  
                return data.result;
                
               }
        else {
            let errorList = [];
            errorList.push("You are not authorised. Please contact to your Administrator!!");
            showMessage(errorList, true, 'error');
            setIserror(true);
           }

    }
   
    function getPhyInvLandingmenues()
    {
        if (physicalInventory != null && physicalInventory.response && physicalInventory.response.applicationId===3) {
            const appID=physicalInventory.response.applicationId;
            const headers = {
             Authorization: "Bearer " + physicalInventory.tokenString,
             UserEmail: physicalInventory.response.emailId,
             userId: physicalInventory.uid,
             RoleName: physicalInventory.response.roleName,
             Gid: physicalInventory.response.gid,
             Roleid: physicalInventory.response.roleId,
             //AzureToken: token,
           };
           return fetch ("MasterDetails/GetLandingMenuData?appid="+ appID ,{headers:headers
           })
              .then((response) => response.json())
              .then((data) => {
                dispatch(storePhyInvLandingMenuItemsAction(data)) 
                //console.log(data,'physicalInventory landingsubmenu');
                // const phyInvData =data;
                setphyInvData(data);
                
                
              })
              .catch((error) => {
                console.log("Error : ", error);
              });
        }else{
            setPhyInvMenuName(null);
        }
    }
    function phyInventory() {
       
        if (physicalInventory != null  && physicalInventory.response && physicalInventory.response.applicationId===3) {
                dispatch(saveUIDAction(physicalInventory.uid));
                dispatch(saveBearerTokenAction(physicalInventory.tokenString));
                dispatch(storeUserDetailsAction(physicalInventory.response));
                dispatch(AppIDAction(physicalInventory.response.applicationId))
           
                const filterItems=phyInvData?.result?.filter(item=> item.isMainMenu===true);
                dispatch(storeLandingMenuItemsAction(filterItems))
                
                    localStorage.setItem("ApplicationId", 3);
   
                    //window.location.href = '/HomeInventory';

                    return phyInvData.result;
                
                
            
        }
        else {
            let errorList = [];
            
            errorList.push("You are not authorised ,Please contact to your Administrator!!");
            showMessage(errorList, true, 'error');
            setIserror(true);
       
               
           
        
        }

    }
    return (
        // <p>hi</p>
                <Grid container spacing={1} className="position-relative">
               <Grid item xs={12} sm={6} className="home-user-description" >
               
                <div className="description-block">
                    <div className="d-flex">
                        <div className="description-bdr"></div>
                        {/*<h1 className="mt-0 get-MyId-username clr-white"> Hello, {firstName} {lastName}</h1>*/}
                        <h1 className="mt-0 get-MyId-username clr-white"> Hello, {userfirstname} {userlastName}</h1>
                    </div>
                    <Typography className="clr-white project-desc">
                        Welcome to E-Performance & Physical Inventory
                    </Typography>
                                       <div className="d-flex">
                        {/*<Button variant="contained" component={Link} to="/Home" onClick={ePerformance} className="homepage-master-btn ns-btn-hero">*/}
                        {(Eperformance != null && Eperformance.response && Eperformance.response.applicationId===2) ?
                        <Button variant="contained" component={Link} to="/Home"  onClick={()=>ePerformance()} className="homepage-master-btn ns-btn-hero">
                            <span className="f-20 fw-bold">{EperforMenuName}</span>
                        </Button>: <Button variant="contained" onClick={()=>ePerformance()} className="homepage-master-btn ns-btn-hero">
                            <span className="f-20 fw-bold">E - Performance</span>
                        </Button>
                        }
                            {/* <Button variant='contained' component={Link} to="/Home" onClick={ePerformance} >
                            <span className="f-20 fw-bold">{EperforMenuName}</span>
                            </Button> */}
                    
                        {/*<Button variant="contained" component={Link} to="/HomeInventory" onClick={phyInventory} className="homepage-master-btn ns-btn-hero">*/}
                            {/* <Button variant="contained" component={Link} to="/HomeInventory" onClick={()=>phyInventory()} className="homepage-master-btn ns-btn-hero">
                            <span className="f-20 fw-bold">{PhyInvMenuName?PhyInvMenuName:'Physical Inventory'}</span>
                            </Button> */}
                             {(physicalInventory != null && physicalInventory.response && physicalInventory.response.applicationId===3) ?
                        <Button variant="contained" component={Link} to="/HomeInventory"  onClick={()=>phyInventory()} className="homepage-master-btn ns-btn-hero">
                            <span className="f-20 fw-bold">{'Physical Inventory'}</span>
                        </Button>: <Button variant="contained" onClick={()=>phyInventory()} className="homepage-master-btn ns-btn-hero">
                            <span className="f-20 fw-bold">Physical Inventory</span>
                        </Button>
                        }
                    </div>
                                       <Grid item xs={12} sm={12} className="userManagement mt-1 mb-1">
                        <div>
                            {iserror &&
                                <Alert severity={severity} onClose={handleErrorClose}>
                                    {errorMessages.map((msg, i) => {
                                        return <div key={i}>{msg}</div>
                                    })}
                                </Alert>
                            }
                        </div>
                    </Grid>
                   
                    
                </div>
               
                
            </Grid>
                        
            
            <Grid item xs={12} sm={6} className="cognisphere-vid-block" id="CognisphereVid">
                <video autoPlay loop muted className="width-100 height-100">
                    <source src={"../assets/animation/cognisphere_home.mp4"} type="video/mp4" />
                </video>
            </Grid>
            

        </Grid>
             );
             
}
